module.exports = __webpack_public_path__ + "img/symbols.9d076e78.svg";